export interface ZrxQuoteResponse {
    allowanceTarget: string;
    buyTokenAddress: string;
    buyAmount: string;
    data: string;
    sellTokenAddress: string;
    sellAmount: string;
    chainId: number;
    to: string;
    gas: string;
    gasPrice: string;
    estimatedGas: string;
    value: string;
}
